import locale from "localization/en";

export const columns = [
  { key: "priceMovementId", text: locale.priceMovementId, width: "200px" },
  { key: "effectiveDateTime", text: locale.effectiveDateAndTime, width: "170px" },
  { key: "createdAt", text: locale.createdAt, width: "150px" },
  { key: "processedBy", text: locale.processedBy, width: "160px" },
  { key: "priceMovementType", text: locale.priceMovementType, width: "140px" },
  { key: "products", text: locale.products, width: "170px" },
  { key: "movement", text: locale.movement, width: "100px" },
  { key: "amount", text: locale.amount, width: "120px" },
  { key: "actions", text: locale.action, width: "80px" },
];
